import { Link, useLocation } from "wouter";
import { ChevronLeft, Database, Brain, Send, Zap } from "lucide-react";

const ITEMS = [
  { href: "/app/admin/sites", label: "Asset registry", icon: Database },
  { href: "/app/admin/models", label: "AI model registry", icon: Brain },
  { href: "/app/admin/recipients", label: "Alert recipients", icon: Send },
  { href: "/app/admin/demo", label: "Demo launcher", icon: Zap },
];

export function AdminNav() {
  const [location] = useLocation();
  return (
    <nav className="flex items-center gap-1 flex-wrap" data-testid="admin-nav">
      <Link
        href="/app"
        className="text-xs text-slate-500 hover:text-slate-200 inline-flex items-center gap-1 mr-2"
        data-testid="admin-nav-back"
      >
        <ChevronLeft className="size-3" /> Dashboard
      </Link>
      {ITEMS.map(({ href, label, icon: Icon }) => {
        const active = location === href;
        return (
          <Link
            key={href}
            href={href}
            data-testid={`admin-nav-${href.split("/").pop()}`}
            className={`text-xs px-2 py-1 rounded border inline-flex items-center gap-1 ${
              active
                ? "border-teal-500 text-teal-300 bg-teal-500/10"
                : "border-slate-700 text-slate-300 hover:border-slate-500"
            }`}
          >
            <Icon className="size-3" />
            {label}
          </Link>
        );
      })}
    </nav>
  );
}
